import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getInfoForDashboard } from "../../services/maestro/maestro.service";
import { useCallback } from "react";
import { handlerErrorV2 } from "../../utils/errors";
import {
  toggleLoadingDashboard,
  updateDashboardDatasets,
} from "../../store/actions/class-marking.actions";

const useAnalytics = () => {
  const { classId, ulId, curriculumId } = useParams();
  const currentCurriculum = useSelector(
    (state) => state?.assessment?.currentCurriculum || {}
  );
  const dispatch = useDispatch();

  const updateInfoDashboard = useCallback(
    async (lcId) => {
      try {
        dispatch(toggleLoadingDashboard(true));
        const response =
          await getInfoForDashboard(
            curriculumId,
            classId,
            ulId,
            lcId,
            {
              studentIds: [],
            }
          );
        if (response.error) {
          return { error: true, message: response.message };
        }
        dispatch(updateDashboardDatasets(response.data));
        return { error: false, data: response.data };
      } catch (error) {
        const message = handlerErrorV2(error);
        return { error: true, message };
      } finally {
        dispatch(toggleLoadingDashboard(false));
      }
    },
    [classId, curriculumId, ulId, currentCurriculum]
  );

  return {
    updateInfoDashboard,
  };
};

export default useAnalytics;
